module.exports = __webpack_public_path__ + "img/28.fed09e0f.png";